var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLockClosed(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 21,
    viewBox: "0 0 16 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.5 20.3397V7.33979H3.5V5.33979C3.5 4.09109 3.93782 3.02893 4.81345 2.15329C5.6891 1.27766 6.75127 0.839844 7.99997 0.839844C9.24867 0.839844 10.3108 1.27766 11.1865 2.15329C12.0621 3.02893 12.5 4.09109 12.5 5.33979V7.33979H15.5V20.3397H0.5ZM1.99997 18.8398H14V8.83977H1.99997V18.8398ZM7.99997 15.5897C8.48587 15.5897 8.89901 15.4196 9.23938 15.0792C9.57976 14.7388 9.74995 14.3257 9.74995 13.8398C9.74995 13.3539 9.57976 12.9407 9.23938 12.6004C8.89901 12.26 8.48587 12.0898 7.99997 12.0898C7.51407 12.0898 7.10094 12.26 6.76058 12.6004C6.42019 12.9407 6.25 13.3539 6.25 13.8398C6.25 14.3257 6.42019 14.7388 6.76058 15.0792C7.10094 15.4196 7.51407 15.5897 7.99997 15.5897ZM4.99997 7.33979H11V5.33979C11 4.50646 10.7083 3.79813 10.125 3.21479C9.54164 2.63146 8.83331 2.33979 7.99997 2.33979C7.16664 2.33979 6.45831 2.63146 5.87497 3.21479C5.29164 3.79813 4.99997 4.50646 4.99997 5.33979V7.33979Z",
    fill: "#EB1700"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLockClosed);
export default __webpack_public_path__ + "static/media/LockClosed.c2d90322fdcd9fbfa73dd51390423a29.svg";
export { ForwardRef as ReactComponent };